import * as React from "react";
const CreditCard = props => <symbol viewBox="0 0 24 24" {...props}>
    <path d="M6 13.75h4a.75.75 0 100-1.5H6a.75.75 0 100 1.5zm13-9.5H5A2.753 2.753 0 002.25 7v10A2.753 2.753 0 005 19.75h14A2.752 2.752 0 0021.75 17V7A2.753 2.753 0 0019 4.25zM20.25 17A1.25 1.25 0 0119 18.25H5A1.251 1.251 0 013.75 17V9.75h16.5zm0-8.75H3.75V7A1.251 1.251 0 015 5.75h14A1.251 1.251 0 0120.25 7z" />
  </symbol>;
export default CreditCard;